import moment from 'moment';

export function resolveExpiryDate(
  expiryDate?: Date | null,
  startDate?: Date | null,
  termDurationDays?: number | null
): Date | null {
  if (expiryDate && moment(expiryDate).isValid()) return expiryDate;

  if (startDate && termDurationDays != null && termDurationDays > 0) {
    const start = moment(startDate);
    if (!start.isValid()) return null;
    return start.add(termDurationDays, 'days').toDate();
  }

  return null;
}

/**
 * Calendar days until the warranty term ends.
 * Returns `null` when expiry cannot be determined so callers do not treat a missing date as "today".
 */
export function getDaysUntilExpiry(
  expiryDate?: Date | null,
  startDate?: Date | null,
  termDurationDays?: number | null,
  now: Date = new Date()
): number | null {
  const resolved = resolveExpiryDate(expiryDate, startDate, termDurationDays);
  if (!resolved) return null;

  const expiry = moment(resolved);
  if (!expiry.isValid()) return null;

  return expiry.startOf('day').diff(moment(now).startOf('day'), 'days');
}

export function getRemainingTermLabel(daysToExpiry: number | null | undefined): string {
  if (daysToExpiry == null || daysToExpiry < 0) return '';
  if (daysToExpiry === 0) return 'Expires today';
  return `Expires in ${daysToExpiry} day${daysToExpiry > 1 ? 's' : ''}`;
}
